import { ButtonContainer, Buttons } from "../../../generic-sprites/Buttons"
import { Audio } from "../../../utils/Audio"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { EveryCigPart1Audio } from "../EveryCigAssets"
import { EveryCigStore } from "../EveryCigStore"
import { EveryCigBodyPart } from "../EveryCigTypes"
import { EveryCigMovieContainer } from "./EveryCigMovieContainer"


export class EveryCigBodyPartButton {
    private static playedAll = false
    private static bodyPointMap = (): Map<EveryCigBodyPart, { x: number, y: number }> => new Map([
        [EveryCigBodyPart.BRAIN, {x: Scale.x(0.28), y: Scale.y(0.06)}],
        [EveryCigBodyPart.EYE, {x: Scale.x(0.28), y: Scale.y(0.13)}],
        [EveryCigBodyPart.HEART, {x: Scale.x(0.26), y: Scale.y(0.37)}],
        [EveryCigBodyPart.LUNGS, {x: Scale.x(0.3), y: Scale.y(0.42)}]
    ])
    button: ButtonContainer
    line: Phaser.Graphics
    private played: boolean

    constructor(
        private game: Phaser.Game,
        private part: EveryCigBodyPart,
        private voteButton: ButtonContainer,
        private enable: () => void,
        private disable: () => void,
        fadeIn: () => void,
        fadeOut: () => void,
        private group: Phaser.Group,
        x: number,
        y: number
    ) {
        this.button = Buttons.create(game, part,
            () => EveryCigMovieContainer.playCigVideo(game, part, this.onComplete),
            {debug: true, group, x, y})
        this.button.button.alpha = 0
        this.button.text.alpha = 0

        const bodyPoint = EveryCigBodyPartButton.bodyPointMap().get(part)
        const line = new Phaser.Line(this.button.button.x, this.button.button.y + (this.button.button.height / 2), bodyPoint.x, bodyPoint.y)
        this.line = game.add.graphics()
        group.add(this.line)
        this.line.lineStyle(2, Phaser.Color.BLACK)
        this.line.moveTo(line.start.x, line.start.y)
        this.line.lineTo(line.end.x, line.end.y)
        this.line.endFill()
        this.line.alpha = 0

        this.played = false
        this.button.bringToTop()
    }

    onComplete = () => {
        this.played = true
        EveryCigStore.instance.part = this.part
        if (EveryCigBodyPartButton.playedAll) {
            this.voteButton.enable()
        }
        if (EveryCigStore.instance.parts.length === 4 && !EveryCigBodyPartButton.playedAll) {
            EveryCigBodyPartButton.playedAll = true

            Audio.add(this.game, EveryCigPart1Audio.TIME_TO_VOTE, {
                onPlay: () => this.disable(),
                onStop: () => {
                    this.voteButton.enable()
                    this.enable()
                }
            })
        } else {
            this.enable()
        }
    }

    disableButton = () => this.button.disable()

    enableButton = () => {
        this.button.enable()
        if (this.played) {
            this.button.grayOut()
        }
    }

    fadeIn = () => {
        Sprites.fadeGroup(this.group, {fadeDuration: 1000})
        this.button.bringToTop()
    }

    fadeOut = () => {
        Sprites.fadeGroup(this.group, {fadeIn: false, fadeDuration: 1000})
        this.button.button.inputEnabled = false
    }

    setNewButton = (button: ButtonContainer) => this.voteButton = button
}
